<template>
    <div v-show="!isLoading" class="card mx-3 mt-2 mt-lg-0 mb-lg-2 mb-0" style="cursor:pointer; min-height: 97px;" :class="{active: active}" @click="selectConversation">
        <div class="card-body p-3">
            <div class="row">
                <div class="col-2">
                    <div class="rounded-circle mr-3" v-bind:style="officeLogo" v-show="showOfficeLogo"></div>
                    <img class="rounded-circle mr-3" style="max-width: 100%; height: auto;" :src="teacherImage" @error="setToDefaultImage" v-if="showTeacherImage">
                </div>
                <div class="col-10 ps-0">
                    <div class="row no-gutters">
                        <div class="col-8 col-lg-7">
                            <h6 class="my-0 text-base" v-if="conversation.teacher_id === null" :class="{'fw-bold': unreadMessage, 'font-weight-normal': !unreadMessage }">{{ office.office_name }}</h6>
                            <h6 class="my-0 text-base" v-if="conversation.teacher_id" :class="{'fw-bold': unreadMessage, 'font-weight-normal': !unreadMessage }">{{ teacher.name }}</h6>
                        </div>
                        <div class="col-4 col-lg-5 text-end">
                            <small>{{ shortFormattedSent }}</small>
                        </div>

                        <div class="col-10">
                            <p class="mb-0" v-if="lastMessage">
                            <small>
                                <span v-show="conversation.last_message.type === 'IN_CHAT'">{{ $t('Deg') }}: </span>
                                {{ lastMessage }}
                            </small>
                            </p>
                            <p class="mb-0" v-if="!lastMessage">
                                <small :class="{'text-black-50': !active, 'text-white-50': active}"><i>{{ $t('Ingen meldinger') }}</i></small>
                            </p>
                        </div>
                        <div class="col-2 text-end">
                            <span class="text-elev-blue fas fa-circle" v-show="unreadMessage"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from '../../state/chatStore';

const props = defineProps(['conversation']);

const unreadMessage = computed(() => {
    if (props.conversation.last_message) {
        return props.conversation.last_message.read === null && props.conversation.last_message.type === 'OUT_CHAT' && !active.value;
    }
    return false;
});

const active = computed(() => Store.getActiveConversationId() === props.conversation.id);
const isLoading = computed(() => Store.isLoading());
const office = computed(() => Store.getOffice());

const teacher = computed(() => {
    if (!props.conversation.teacher_id) {
        return null;
    }
    return Store.getTeacher(props.conversation.teacher_id);
});

const showOfficeLogo = computed(() => !props.conversation.teacher_id && office.value.office_logo);
const officeLogo = computed(() => {
    return {
        width: '100%',
        paddingBottom: '100%',
        backgroundImage: 'url("' + office.value.office_logo + '")',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#fff',
    };
});

const showTeacherImage = computed(() => teacher.value);
const teacherImage = computed(() => {
    if (!teacher.value.user_image) {
        return defaultImage.value;
    }
    return window.enforceCDN('/img/ansatte/' + teacher.value.user_image);
});

const defaultImage = computed(() => window.enforceCDN('/web/resources/img/man_stilo_150.png'));

const lastMessage = computed(() => {
    const lastMessage = props.conversation.last_message;

    if (!lastMessage) {
        return null;
    }

    if (lastMessage.message.length > 85) {
        return lastMessage.message.substr(0, 85) + '...';
    }
    return lastMessage.message;
});

const shortFormattedSent = computed(() => {
    if (props.conversation.last_message) {
        return props.conversation.last_message.shortFormattedSent;
    }
    return '';
});

const selectConversation = () => {
    if (props.conversation.id === Store.getActiveConversationId()) {
        // Same conversation, do nothing
        return;
    }
    Store.loadConversation(props.conversation);
};

const setToDefaultImage = (ev) => {
    ev.target.src = defaultImage.value;
};
</script>